import { BaseRepository } from '@/base/base-repository';
import { APP_CFG } from '@/configs';
import { Lootboxes, mapToLootboxes } from '@/dtos';
import { SuiClient } from '@mysten/sui/client';

class UserRepository extends BaseRepository {
	async getBalance(client: SuiClient, address: string): Promise<number> {
		const response = await client.getBalance({ owner: address });
		return parseInt(response.totalBalance, 10);
	}

	async getLootboxes(client: SuiClient): Promise<Lootboxes> {
		const response = await client.getObject({
			id: APP_CFG.LOOTBOX_LOOTBOXGAME_SUI_SUI,
			options: {
				showContent: true,
			},
		});

		return mapToLootboxes(response.data);
	}

	async getSuiCoin(client: SuiClient, address: string) {
		const response = await client.getOwnedObjects({
			owner: address,
			options: {
				showContent: true,
			},
			filter: {
				StructType: `0x2::coin::Coin<0x2::sui::SUI>`,
			},
		});

		return response.data[response.data.length - 1];
	}

	async healthCheck(): Promise<boolean> {
		try {
			const response = await this.httpClient({ method: 'get', url: '/health' });
			return response.status === 'ok';
		} catch {
			throw new Error('Suigar is temporarily unavailable, please try again soon!');
		}
	}
}

export const userRepository = new UserRepository();
